export const SITE = {
  name: "AURIK INGREVIA (P) Ltd.",
  shortName: "Aurik Ingrevia",
  tagline: "Bio-scientific feed additives & animal nutrition",
  phone: "+91 9910050608",
  email: "info@fnni.in",
  groupCompany: "Gait Naurish (I) Ltd.",
  backend: process.env.REACT_APP_BACKEND_URL,
};

export const NAV_LINKS = [
  { label: "Home", to: "/" },
  { label: "About", to: "/about" },
  { label: "Products", to: "/products" },
  { label: "Applications", to: "/applications" },
  { label: "Quality & R&D", to: "/quality-rd" },
  { label: "Contact", to: "/contact" },
];

export const FORM = "Free flow powder";
export const USE = "Mineral mixture, complementary feed or complete feed";

export const CATEGORIES = [
  { slug: "palatants-sweeteners", label: "Palatants & Sweeteners" },
  { slug: "toxin-management", label: "Toxin Management" },
  { slug: "gut-health-acidifiers", label: "Gut Health & Acidifiers" },
  { slug: "emulsifiers-energy", label: "Emulsifiers & Energy" },
  { slug: "herbal-nutraceutical", label: "Herbal & Nutraceutical Extracts" },
  { slug: "mineral-nutrition", label: "Mineral Nutrition" },
];

const static_ = (id) => `https://static.prod-images.emergentagent.com/jobs/5be8e831-3f36-4fa5-8cdd-72642e1fe83c/images/${id}.jpeg`;

export const IMG = {
  hero: static_("44273941194e33574bf023679db683cf9a16c2f3192ffad4043cc2481a82d6b6"),
  pearls: static_("b396a686fe41e1843bbcb20d7a3585b0f1aadd2f40045486c83d763c6fec78a7"),
  banana: static_("20de76f49335aa7700fc9855e0bc18ddfa22491cf88e44c3c1b6aaea1092fd05"),
  yellow: static_("a02b030ff9d24ff79ee789c0f4f77943393a5e34fb15a7723d258ab2e26fe074"),
  whitePowder: static_("763598ab47ed91dbdab2e89f1a27c280841d1301a074fd72298eb3f6ae31f935"),
  blackPowder: static_("419b304a74055fcd4d8e6173dd1e7dbded92e7cf56aeba0a312a3dbb9e9258f1"),
  molasses: static_("001e0d76b90df4e0dab83f42074abbbdba5840654709527516cb6af3183825f8"),
  vanilla: static_("d299a355332506a108a086bc4f68d0317df485a5015d0bff9b26d89fa0266ea9"),
  coconut: static_("15fe853bf87858848811dbd6e58c1f8bc62362ea3f076a7b28cdce1f2cef933b"),
  charcoal: static_("f20de2db1b4333a6f563e83b13f4ebd58550b1a9f2f486bccb95da070ccf1a20"),
  beads: static_("5f47154e5fbe0fc668936495c4892f2bdc2b19c9a6ec499142bcbe06e69ce8a3"),
  turmeric: static_("6358eba11b815ca1808152b364f972e1cc8822d9e4176cc0c290e53c16caf4f8"),
  roots: static_("03617c3598eede885fcf7196fafb7227ca5beeb59734aa76db9be385d31311da"),
  ruminant: "https://images.unsplash.com/photo-1665105519765-a0ec8e027100?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  poultry: "https://images.unsplash.com/photo-1596646532903-ad5a3b364751?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  aqua: "https://images.unsplash.com/photo-1596519398082-726c1594c985?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  swine: "https://images.unsplash.com/photo-1655307550020-3eb7efdef723?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  lab: "https://images.unsplash.com/photo-1748263582756-082fe4adaa5b?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  labScientist: "https://images.unsplash.com/photo-1787058124508-091eb8a023e2?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
};

const CATTLE_ONLY = ["Calf & Ruminant"];

export const PRODUCTS = [
  {
    slug: "palatisure-650",
    name: "PalatiSure 650",
    category: "palatants-sweeteners",
    tagline: "High intensity feed sweetener — 650x sugar sweetness",
    image: IMG.whitePowder,
    form: "White colour free flowing powder",
    species: CATTLE_ONLY,
    use: USE,
    inclusion: "100–200 g/ton finished feed",
    status: "available",
    description:
      "PalatiSure 650 is a high intensity feed sweetener delivering 650x the sweetness of sugar. An immediate intense sweetness burst with no aftertaste, persistent sweetness, and excellent stability in high temperature pelleting. Its well-rounded sweetness stimulates the gustatory nerves and enhances palatability under reduced appetite and nutritional stress.",
    features: [
      "Immediate intense sweetness burst, no aftertaste",
      "Persistent sweetness",
      "Excellent stability in high temperature pelleting",
      "Well-rounded sweetness stimulating gustatory nerves",
      "Proprietary Micropearl process — uniform particle size, controlled release, synergistic high-potency sweeteners",
      "Enhances palatability under reduced appetite / nutritional stress",
    ],
  },
  {
    slug: "feedlure-101",
    name: "FeedLure 101",
    category: "palatants-sweeteners",
    tagline: "Palatant — Milky Vanilla (Lacto Vanilla)",
    image: IMG.vanilla,
    form: FORM,
    species: CATTLE_ONLY,
    use: USE,
    inclusion: "500–1000 g/ton",
    status: "available",
    description:
      "FeedLure 101 is a lacto-vanilla palatant with intense vanilla and milky notes mimicking milk and vanilla. It supports intake during stress, feed change and reduced appetite — in young and mature animals alike.",
    features: [
      "Intense vanilla and milky notes mimicking milk and vanilla",
      "Supports intake in stress, feed change, reduced appetite",
      "Suited to young and mature animals",
    ],
  },
  {
    slug: "feedlure-201",
    name: "FeedLure 201",
    category: "palatants-sweeteners",
    tagline: "Palatant — Molasses",
    image: IMG.molasses,
    form: FORM,
    species: CATTLE_ONLY,
    use: USE,
    inclusion: "500–1000 g/ton",
    status: "available",
    description:
      "FeedLure 201 is a molasses-type palatant with warm, sweet brown sugar notes. High-temperature resistant granulation delivers an intense, stable aroma while the formulation resists agglomeration, disperses uniformly in mash and pellets, and keeps a stable shelf life with excellent flowability.",
    features: [
      "Warm, sweet brown sugar notes",
      "High-temp resistant granulation, intense stable aroma",
      "Resists agglomeration, uniform dispersion in mash and pellets",
      "Stable shelf life, excellent flowability",
    ],
  },
  {
    slug: "feedlure-301",
    name: "FeedLure 301",
    category: "palatants-sweeteners",
    tagline: "Palatant — Banana",
    image: IMG.yellow,
    form: "Yellow colour free flow powder",
    species: CATTLE_ONLY,
    use: USE,
    inclusion: "500 g/ton",
    status: "available",
    description:
      "FeedLure 301 is a fruity, sweet-banana flavour palatant built on high-temperature resistant granulation with an intense, stable aroma. It stimulates appetite and voluntary intake during stress and feed transitions.",
    features: [
      "High-temp resistant granulation",
      "Intense, stable aroma",
      "Stimulates appetite and voluntary intake in stress and feed transitions",
    ],
  },
  {
    slug: "feedlure-302",
    name: "FeedLure 302",
    category: "palatants-sweeteners",
    tagline: "Palatant — Milky Vanilla & Coconut",
    image: IMG.coconut,
    form: FORM,
    species: CATTLE_ONLY,
    use: USE,
    inclusion: "500–750 g/ton",
    status: "available",
    description:
      "FeedLure 302 is a multi-layered milky vanilla and coconut palatant designed for starter feeds, recovery diets and transition phases. Thermostable, with excellent flow and uniform aroma release.",
    features: [
      "Multi-layered milky vanilla & coconut profile",
      "For starter feeds, recovery diets, transition phases",
      "Thermostable, excellent flow, uniform aroma release",
    ],
  },
  {
    slug: "feedlure-401",
    name: "FeedLure 401",
    category: "palatants-sweeteners",
    tagline: "Palatant — Cheese profile",
    image: IMG.vanilla,
    form: FORM,
    species: CATTLE_ONLY,
    use: USE,
    inclusion: "On request",
    status: "coming-soon",
    description:
      "FeedLure 401 extends the FeedLure range with a cheese flavour profile. Formulation details and inclusion rates are available on request.",
    features: ["Cheese flavour profile", "Extension of the FeedLure range"],
  },
  {
    slug: "feedlure-402",
    name: "FeedLure 402",
    category: "palatants-sweeteners",
    tagline: "Palatant — Butter / Dairy type",
    image: IMG.molasses,
    form: FORM,
    species: CATTLE_ONLY,
    use: USE,
    inclusion: "On request",
    status: "coming-soon",
    description:
      "FeedLure 402 extends the FeedLure range with a butter and dairy-type flavour profile. Formulation details and inclusion rates are available on request.",
    features: ["Butter / dairy flavour profile", "Extension of the FeedLure range"],
  },
  {
    slug: "tox-shield-pro",
    name: "Tox-Shield Pro",
    category: "toxin-management",
    tagline: "Broad-spectrum toxin binder with enzymatic detoxification",
    image: IMG.blackPowder,
    form: "Free flowing black colour powder",
    species: ["Calf & Ruminant", "Poultry"],
    use: USE,
    inclusion: "1–2 kg/ton",
    status: "available",
    description:
      "Tox-Shield Pro is a multi-component toxin management premix combining HSCAS, activated calcium bentonite, yeast cell wall, MOS, activated charcoal, an organic acidifier, aflatoxin oxidase enzyme (ADTZ) and curcumin extract. It targets Aflatoxin B1 to help control M1 in milk.",
    features: [
      "HSCAS + activated calcium bentonite + yeast cell wall + MOS + activated charcoal",
      "Aflatoxin oxidase (ADTZ) enzymatic detoxification",
      "Targets Aflatoxin B1 to help control M1 in milk",
      "Organic acidifier and curcumin extract",
    ],
  },
  {
    slug: "emulsure",
    name: "EmulSure",
    category: "emulsifiers-energy",
    tagline: "Nutritional emulsifier for poultry rations",
    image: IMG.beads,
    form: FORM,
    species: ["Poultry"],
    use: USE,
    inclusion: "On request",
    status: "available",
    description:
      "EmulSure is a nutritional emulsifier for poultry feeds, designed to support lipid utilisation, spare dietary energy and contribute to feed conversion ratio improvement.",
    features: ["Supports lipid utilisation", "Energy sparing effect", "Supports FCR improvement"],
  },
  {
    slug: "acid-pro",
    name: "Acid Pro",
    category: "gut-health-acidifiers",
    tagline: "Feed acidifier blend for gut pH control",
    image: IMG.pearls,
    form: FORM,
    species: ["Calf & Ruminant", "Poultry", "Swine"],
    use: USE,
    inclusion: "On request",
    status: "available",
    description:
      "Acid Pro is a feed acidifier blend designed to support gut pH control, microbial balance and nutrient digestibility across production phases.",
    features: ["Supports gut pH control", "Supports microbial balance", "Supports nutrient digestibility"],
  },
  {
    slug: "curculiv",
    name: "CurcuLiv",
    category: "herbal-nutraceutical",
    tagline: "Liver tonic with curcumin and herbal extracts",
    image: IMG.turmeric,
    form: FORM,
    species: ["Calf & Ruminant", "Poultry"],
    use: USE,
    inclusion: "On request",
    status: "available",
    description:
      "CurcuLiv is a liver tonic formulation based on curcumin and standardised herbal extracts, developed to support liver function and metabolic resilience.",
    features: ["Curcumin-based liver support", "Standardised herbal extracts"],
  },
  {
    slug: "ashwagandha-extract",
    name: "Ashwagandha Extract",
    category: "herbal-nutraceutical",
    tagline: "Botanical extract of Withania somnifera",
    image: IMG.roots,
    form: FORM,
    species: ["Calf & Ruminant", "Poultry", "Swine"],
    use: USE,
    inclusion: "On request",
    status: "available",
    description:
      "Ashwagandha Extract brings the botanical Withania somnifera to feed, for nutritional support of stress adaptation and vitality.",
    features: ["Withania somnifera botanical extract", "Supports stress adaptation"],
  },
  {
    slug: "trace-mineral-pro",
    name: "Trace Mineral Pro",
    category: "mineral-nutrition",
    tagline: "Trace mineral premix for balanced mineral nutrition",
    image: IMG.beads,
    form: FORM,
    species: ["Calf & Ruminant", "Poultry", "Swine", "Aqua"],
    use: USE,
    inclusion: "On request",
    status: "available",
    description:
      "Trace Mineral Pro is a trace mineral premix supplying essential trace elements for balanced mineral nutrition across species and production phases.",
    features: ["Essential trace elements", "For mineral mixture, complementary or complete feed"],
  },
];

export const SPECIES = [
  {
    slug: "calf-ruminant",
    label: "Calf & Ruminant",
    image: IMG.ruminant,
    intro:
      "From the milk-feeding phase to the productive dairy cow, intake drives everything. Aurik palatants ease weaning and feed transitions, while Tox-Shield Pro targets Aflatoxin B1 to help control M1 in milk.",
    challenges: [
      "Weaning and feed transition dips in starter intake",
      "Reduced appetite under heat stress and nutritional stress",
      "Aflatoxin B1 in ration and the risk of M1 carry-over into milk",
      "Palatability of mineral mixtures and complementary feeds",
    ],
    recommended: ["palatisure-650", "feedlure-301", "feedlure-302", "tox-shield-pro", "trace-mineral-pro"],
  },
  {
    slug: "poultry",
    label: "Poultry",
    image: IMG.poultry,
    intro:
      "Broiler and layer performance is won at the gut and the feed mill. Our poultry programme pairs emulsification and acidification with pellet-stable flavour that survives high-temperature conditioning.",
    challenges: [
      "Heat stress depressing voluntary feed intake",
      "Fat digestion and energy cost of production (FCR pressure)",
      "Gut pH control and microbial balance",
      "Aroma loss through high-temperature pelleting",
    ],
    recommended: ["emulsure", "acid-pro", "palatisure-650", "tox-shield-pro"],
  },
  {
    slug: "aqua",
    label: "Aqua",
    image: IMG.aqua,
    intro:
      "In water, feed must be found first and eaten fast. Attractive, stable flavour and balanced trace mineralisation support intake and uniform growth in intensive ponds and cages.",
    challenges: [
      "Attracting and holding intake in water",
      "Stress at stocking, grading and transport",
      "Uniform growth across the pond",
      "Mineral nutrition in intensive systems",
    ],
    recommended: ["feedlure-101", "palatisure-650", "trace-mineral-pro"],
  },
  {
    slug: "swine",
    label: "Swine",
    image: IMG.swine,
    intro:
      "Post-weaning intake sets lifetime performance. Multi-layered milky and sweet profiles keep piglets eating through starter, transition and recovery phases.",
    challenges: [
      "Post-weaning feed intake gap",
      "Starter, transition and recovery diet changes",
      "Gut health through acidification",
      "Stress resilience in intensive housing",
    ],
    recommended: ["feedlure-302", "feedlure-201", "acid-pro", "ashwagandha-extract"],
  },
];

export const PRODUCT_BY_SLUG = Object.fromEntries(PRODUCTS.map((p) => [p.slug, p]));
export const CATEGORY_BY_SLUG = Object.fromEntries(CATEGORIES.map((c) => [c.slug, c.label]));
export const SHEET_URL = (slug) => `${SITE.backend}/api/products/${slug}/sheet`;
